import { MigrationStatus } from '../migration-reusable-components/migration-status.enum';
import { MigrationSource } from '../migration-reusable-components/migration-source.enum';

interface MigrationResultMetadata {
	competitorCode: string;
	competitorDescription: string;
}
export interface MigrationResult {
	migrationId: string;
	migrationStartDate: number;
	migrationChangeDate: number;
	migrationStatus: MigrationStatus;
	migrationSource: MigrationSource;
	progress: number;
	alertCount: number;
	recordsMigrated: number;
	alertRefLink: string;
	recordsMigratedRefLink: string;
	metadata?: MigrationResultMetadata;
}

/** Response structure from backend, when migrated is initiated */
export class InitMigrationResponse {
	companyId: string;
	description: string;
	initiatorContactId: string;
	migrationId: string;
	migrationSource: MigrationSource;
	migrationStartDate: number;
	migrationStatus: MigrationStatus;
	migrationStatusMessage: string;

	static createMigrationResultFromThis(response: InitMigrationResponse): Array<MigrationResult> {
		const startDate = new Date(response.migrationStartDate).getTime();
		const migrationResult: MigrationResult = {
			migrationId: response.migrationId,
			migrationStartDate: startDate,
			migrationChangeDate: response.migrationStartDate,
			migrationSource: response.migrationSource,
			migrationStatus: response.migrationStatus,
			recordsMigrated: 0,
			alertCount: 0,
			progress: 0,
			recordsMigratedRefLink: '',
			alertRefLink: ''
		};
		return [migrationResult];
	}
}
